import React, {useEffect} from "react";
import {Scrollbars} from "react-custom-scrollbars-2";
import {LazyLoadComponent} from "react-lazy-load-image-component";
import "./assets/css/DarkTheme.css";
import "bootstrap/dist/css/bootstrap.css";
import "material-icons/iconfont/material-icons.css";
import "./assets/css/Default.css";

import {useDispatch, useSelector} from "react-redux";
import {BrowserRouter as Router, Redirect, Route, Switch,} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apps from "./apps";
import Error404 from "./apps/Components/Error404";
import NgLoading from "./apps/Components/NgLoading";
import {validAuthToken} from "./redux/actions/Auth.Action";
import SocketComponent from "./sockets/SocketComponent";
import PrivateRoute from "./Utils/PrivateRoute";
import PublicRoute from "./Utils/PublicRoute";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(validAuthToken());
  }, []);
  const Loading = useSelector((state) => state.Auth.Loading);
  const LockScreen = useSelector((state) => state.Auth.lockPop);
  return (
    <React.Fragment>
      <div
        className="preloader"
        style={{ display: `${Loading ? "" : "none"}` }}
      >
        <NgLoading />
      </div>
      <LazyLoadComponent>
        <Scrollbars style={{ height: "100vh" }}>
          {!LockScreen ? (
            <Router>
              <Switch>
                <PublicRoute path="/" exact>
                  <Redirect to="/Auth" />
                </PublicRoute>
                <PublicRoute path="/Auth" component={apps.Auth.Auth} />
                <PrivateRoute path="/Dashboard" component={apps.Dashboard} />
                <div className="posBody">
                  <PrivateRoute path="/POS" component={apps.POS} />
                  <PrivateRoute path="/Bar" component={apps.Bar} />
                  <PrivateRoute path="/Kitchen" component={apps.Kitchen} />
                  <PrivateRoute path="/Waiter" component={apps.Waiter} />
                  <PrivateRoute path="/CakeRoom" component={apps.CakeRoom} />
                </div>
                <Route path="/MyTableOrder" component={apps.TableOrder} />
                <Route path="*">
                  <Error404 />
                </Route>
              </Switch>
            </Router>
          ) : (
            <apps.Auth.LockScreen />
          )}
          <ToastContainer />
        </Scrollbars>
        <SocketComponent />
      </LazyLoadComponent>
    </React.Fragment>
  );
}

export default App;
